import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M4.93587061,11.0641294 L11.0641294,4.93587061 C10.2799503,4.15169152 9.19661696,3.66666667 8,3.66666667 C5.60676608,3.66666667 3.66666667,5.60676608 3.66666667,8 C3.66666667,9.19661696 4.15169152,10.2799503 4.93587061,11.0641294 Z M8,13 C5.23857625,13 3,10.7614237 3,8 C3,5.23857625 5.23857625,3 8,3 C10.7614237,3 13,5.23857625 13,8 C13,10.7614237 10.7614237,13 8,13 Z"/>
  </svg>
);
